import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Claim } from './claim.model'
import { catchError, map, Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { AuthService } from '../../auth.service'

const API_URL = environment.apiUrl

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  updatePermissionsForUser(userName: string, claims: Claim[]) {
    return this.http
      .post(
        API_URL + '/Auth/AddClaimsForUser',
        { username: userName, claims: claims },
        {
          withCredentials: true,
        },
      )
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  getClaimsForUser(username: string): Observable<any> {
    const params = new HttpParams().set('username', username)
    return this.http
      .get(API_URL + '/Auth/GetClaimsForUser', {
        params,
        withCredentials: true,
      })
      .pipe(
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }

  deleteUser(username: string): Observable<any>{
    return this.http
      .post(
        API_URL + '/Auth/DeleteUser',
        { username: username },
        {
          withCredentials: true,
        },
      )
      .pipe(
        map((response: any) => {
          return response
        }),
        catchError((error: any) => {
          

          throw new HttpErrorResponse({
            status: error.error.statusCode,
            statusText: error.error.response,
          })
        }),
      )
  }
}
